import { buildStyleFromLiteral } from '../tools/services/styles-literal'
import { getColorArray } from '../tools/services/colors'

export default function ({ color = [51, 153, 204], width = 3 } = {}) {
  return buildStyleFromLiteral({
    stroke: { width, color: getColorArray(color) },
  })
}
